import { Component, Input, OnInit } from '@angular/core';
import { MlsService, MlsInfo } from '@app-services/mls.service';

@Component({
	selector: 'app-public-mls',
	templateUrl: './public-mls.component.html',
	styleUrls: ['./public-mls.component.scss']
})
export class PublicMlsComponent implements OnInit {
	@Input() name: string;

	constructor(private mlsService: MlsService) { }

	ngOnInit(): void { }

	getListInfo(value: string): MlsInfo {
		return this.mlsService.getListInfo(value);
	}
}
